import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import PatientPage from "./PatientPage/PatientPage";
import SideBar from "../../components/SideBar/SideBar";
import PatientPayment from "./PatientPayments/PatientPayment";
import {PatientQrResultSwitcher} from "../General/QrResult/QrResult";
import OrgSearch from "../General/OrgSearch";
import {PatientQrResultSwitcher2} from "../General/QrResult2/QrResult2";
import Notifications from "../General/Notificatioins/Notifications";
import {Liteviewer} from "../General/Liteviewer/Liteviewer";

function PatientRoutes() {
    const {REACT_APP_URL_PREFIX} = process.env
    return (
        <Switch>
            <Route path={REACT_APP_URL_PREFIX + '/orgSearch' } exact> <OrgSearch /></Route>

            <Route path={REACT_APP_URL_PREFIX + "/patient-page"} exact>
                <PatientPage/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + "/notifications"} exact>
                <Notifications/>
            </Route>
			
            <Route path={REACT_APP_URL_PREFIX + "/liteviewer/:result_id"} exact>
                <Liteviewer/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + "/patient-payments"} exact>
                <SideBar mobile={true}/>
                <PatientPayment/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + "/checkIn"} exact>
                <PatientQrResultSwitcher/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + '/checkBlank/:data'} exact> <PatientQrResultSwitcher2 /> </Route>

            <Redirect to={REACT_APP_URL_PREFIX + "/patient-page"}/>
        </Switch>
    );
}

export default PatientRoutes;